/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GiveawayType } from './GiveawayType';
import type { Item } from './Item';
export type GiveawayTypeWithItems = (GiveawayType & {
    /**
     * Items in the giveaway pool
     */
    items: Array<Item>;
    /**
     * Whether giveaway type is active
     */
    isActive: boolean;
    /**
     * Whether giveaway type is deleted
     */
    isDeleted: boolean;
    /**
     * Current active round information (if exists)
     */
    currentRound?: {
        /**
         * Round ID
         */
        id: string;
        /**
         * The item for the current round
         */
        item: Item;
        /**
         * When the round ends (null if WAITING)
         */
        endsAt: string | null;
        /**
         * 0=WAITING, 10=ACTIVE, 20=PICKING, 30=DONE, 40=ERROR
         */
        status: GiveawayTypeWithItems.status;
        /**
         * Number of participants in the current round
         */
        participantCount: number;
        /**
         * List of participants with their basic information
         */
        participants: Array<{
            /**
             * User ID
             */
            id: string;
            /**
             * User display name
             */
            name: string;
            /**
             * User avatar URL
             */
            avatar: string;
        }>;
    } | null;
});
export namespace GiveawayTypeWithItems {
    /**
     * 0=WAITING, 10=ACTIVE, 20=PICKING, 30=DONE, 40=ERROR
     */
    export enum status {
        '_0' = 0,
        '_10' = 10,
        '_20' = 20,
        '_30' = 30,
        '_40' = 40,
    }
}

